import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const cleanedBackendUrl = backendUrl.replace("/backend", "");

const OrderService = {
  getOrderList(page, perPage, orderStatus, orderId) {
    return axios.get(
      `${cleanedBackendUrl}/orders/list/all`,
      {
        params: {
          "order-status": orderStatus,
          "order-id": orderId,
          "page": page,
          "per-page": perPage
        }
      }
    );
  },
  getOrderListPartner(page, perPage, orderStatus, orderId, partnerId, dateFrom, dateTo) {
    return axios.get(
      `${cleanedBackendUrl}/orders/list/partner/${partnerId}`,
      {
        params: {
          "order-status": orderStatus,
          "order-id": orderId,
          "page": page,
          "per-page": perPage,
          "date-from": dateFrom,
          "date-to": dateTo
        }
      }
    );
  },
  getListTransactions(page, perPage, partnerId, dateFrom, dateTo) {
    return axios.get(
      `${cleanedBackendUrl}/orders/list/transaction/${partnerId}`,
      {
        params: {
          "date-from": dateFrom,
          "date-to": dateTo,
          "page": page,
          "per-page": perPage
        }
      }
    );
  },
  getListTransactionsPrint(partnerId, dateFrom, dateTo) {
    return axios.get(
      `${cleanedBackendUrl}/orders/list/transaction/${partnerId}/all`,
      {
        params: {
          "date-from": dateFrom,
          "date-to": dateTo,
        }
      }
    );
  },
  acceptOrder(orderId, paymentReference) {
    return axios.put(
      `${cleanedBackendUrl}/orders/${orderId}/accept`,
      {
        paymentReference: paymentReference
      }
    )
  },
  acceptAllOrder() {
    return axios.put(`${cleanedBackendUrl}/orders/accept`);
  },
  createDelivery(paymentId) {
    return axios.post(
      `${cleanedBackendUrl}/delivery/create`,
      {
        key: "IniDipakaiBuatNembakAPI/?.]JanganSampaiDipakeUser_123456*@&#!&%(",
        paymentId: paymentId
      }
    )
  }
};

export default OrderService;